import type { FC } from 'react';

import { Container } from '@src/library/components/ui';
import { MessengerActions, MessengerDialog } from '@src/widgets/messenger';

import * as st from './styles.module.scss';

export const MessengerMainPage: FC = () => {
	return (
		<>
			<Container>
				<div className={st.messenger}>
					<MessengerActions />
					<MessengerDialog />
				</div>
			</Container>
		</>
	);
};
